import React from 'react';
import {get} from 'lodash';
import moment from 'moment';
import axios from 'axios';
import Waypoint from 'react-waypoint';

import {
  metaLoading,
} from '../lib/helpers';

import Loading from './Loading';
import ReportHistoriesTable from './ReportHistoriesTable';

class PostReportHistories extends React.Component {
  state = {
    ...metaLoading,
    shouldFetch: true,
    histories: []
  }

  fetchData = () => {
    if (this.state.shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/report_histories/posts/${get(this.props, 'postId')}`)
      .then((res) => {
        if (res.status == 200 && get(res, 'data')) {
          this.setState({
            histories: res.data['histories'],
            shouldFetch: false,
            meta: {
              isLoading: false
            },
          })
        }
      })
    }
  }

  componentDidMount() {
    this.setState({
      meta: {
        isLoading: true,
      },
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className='MainHeader'>
          <div className="MainHeader__left">
            <h3 className='MainHeader__h3'>Report Histories</h3>
            <p className='MainHeader__left__p'>
              <a href={`/${gon.currentProvider}/report_histories/posts/${get(this.props, 'postId')}`}>View all</a>
            </p>
          </div>
        </div>

        <Waypoint onEnter={this.fetchData}>
          <div><ReportHistoriesTable histories={get(this.state, 'histories', [])}/></div>
        </Waypoint>
      </React.Fragment>
    );
  }
}

export default PostReportHistories
